import { useState } from "react";
import { InventoryDetailInterface } from "../../interfaces/InventoryInterface";
import { FormTextInput } from "../../components/FormFields";

interface InventoryDetailsTableProps {
  data?: InventoryDetailInterface[] | null;
  showItem?: boolean | true;
  showAllStatus?: boolean | false;
}

const InventoryDetailsTable: React.FC<InventoryDetailsTableProps> = ({
  data,
  showItem,
  showAllStatus,
}) => {
  const [filterText, setFilterText] = useState("");

  const filteredData = data?.filter((row) => {
    const statusIsValid = showAllStatus || (row.statusID as number) !== 34; // Assuming 34 is invalid status

    return (
      statusIsValid &&
      (row.shipmentNumber.includes(filterText) ||
        row.serviceName?.includes(filterText) ||
        row.locationDestinationCode.includes(filterText))
    );
  });

  // Total de guías únicas
  const totalShipmentsUnique = filteredData
    ?.filter((x) => (x.statusID as number) !== 38 && (x.statusID as number) !== 34) // Excluyen faltantes=38 y eliminados=34
    .reduce((acumulador, objeto) => {
      acumulador[objeto.shipmentNumber] =
        (acumulador[objeto.shipmentNumber] || 0) + 1;
      return acumulador;
    }, {} as Record<string, number>);

  const totalShipments = Object.keys(totalShipmentsUnique || {}).length;

  // Total peso
  const sumTotalWeight = filteredData
    ?.filter((x) => (x.statusID as number) !== 38 && (x.statusID as number) !== 34)
    .reduce((acumulador, objeto) => acumulador + objeto.physicalWeight, 0);

  // Total de piezas
  const totalPiecesCount =
    filteredData?.filter((x) => (x.statusID as number) !== 38 && (x.statusID as number) !== 34)
      .length || 0;

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between">
        <div className="flex-1 sm:pr-2 mb-4">
          <FormTextInput
            value={filterText}
            label="Filtrar"
            placeholder="Por número de guía, servicio o destino"
            onChange={(e) => setFilterText(e.target.value)}
          />
        </div>

        <div className="flex-1 sm:pl-2 mb-4">
          <label className="block text-m font-medium leading-6 text-gray-800 mb-2 truncate">
            Totales
          </label>
          <div className="border bg-white rounded-xl shadow-md hover:shadow-lg flex flex-col sm:flex-row sm:items-center p-2">
            <div className="flex items-center w-full sm:w-1/3">
              <label className="block text-m leading-6 text-gray-800 truncate mb-1 sm:mb-0 mr-2">
                Total guías:
              </label>
              <span className="text-gray-700 text-sm font-semibold sm:my-1">{totalShipments}</span>
            </div>
            <div className="flex items-center w-full sm:w-1/3">
              <label className="block text-m leading-6 text-gray-800 truncate mb-1 sm:mb-0 mr-2">
                Total piezas:
              </label>
              <span className="text-gray-700 text-sm font-semibold sm:my-1">{totalPiecesCount}</span>
            </div>
            <div className="flex items-center w-full sm:w-1/3">
              <label className="block text-m leading-6 text-gray-800 truncate mb-1 sm:mb-0 mr-2">
                Total peso:
              </label>
              <span className="text-gray-700 text-sm font-semibold sm:my-1">{sumTotalWeight?.toFixed(2)} kg</span>
            </div>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="table-auto w-full">
          <thead>
            <tr className="text-center">
              <th className="px-4 py-2 font-semibold text-xs">GUÍA</th>
              <th className="px-4 py-2 font-semibold text-xs">ORIGEN</th>
              <th className="px-4 py-2 font-semibold text-xs">DESTINO</th>
              <th className="px-4 py-2 font-semibold text-xs">SERVICIO</th>
              <th className="px-4 py-2 font-semibold text-xs">PIEZA</th>
              <th className="px-4 py-2 font-semibold text-xs">TOTAL PIEZAS</th>
              <th className="px-4 py-2 font-semibold text-xs">PESO</th>
            </tr>
          </thead>
          <tbody>
            {filteredData?.map((detail, index) => (
              <tr key={detail.inventoryDetailID} className={`text-center ${index % 2 === 0 ? "bg-gray-50" : "bg-white"}`}>
                <td className="px-4 py-2 text-xs">{detail.shipmentNumber}</td>
                <td className="px-4 py-2 text-xs">{detail.buCodeSource.toUpperCase()}</td>
                <td className="px-4 py-2 text-xs">{detail.locationDestinationCode.toUpperCase()}</td>
                <td className="px-4 py-2 text-xs">{detail.serviceName?.toUpperCase()}</td>
                <td className="px-4 py-2 text-xs">{detail.pieceNumber}</td>
                <td className="px-4 py-2 text-xs">{detail.totalPieces}</td>
                <td className="px-4 py-2 text-xs">{detail.physicalWeight.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default InventoryDetailsTable;